import { render } from "./DataGridWithLeagues.vue?vue&type=template&id=19a58406&ts=true"
import script from "./DataGridWithLeagues.vue?vue&type=script&lang=ts"
export * from "./DataGridWithLeagues.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__